var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'PartDetails', query: _vm.queryProps}}},[_vm._v("\n  "+_vm._s(_vm.oemPartCode)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }